<div class="lang">
    <div class="globe" slot="reference"><img src="/globe_32.png" /></div>
    <span class="lang-select" @click="onLanguageClick('en')"><span :class="selectedLanguage == 'English' ? 'selected' : ''">English</span></span>
    <span class="lang-select" @click="onLanguageClick('ro')"><span :class="selectedLanguage == 'Română' ? 'selected' : ''">Română</span></span>
    <span class="lang-select" @click="onLanguageClick('uk')"><span :class="selectedLanguage == 'українська' ? 'selected' : ''">українська</span></span>
    <div v-if="isUnavailable" class="language-warning">
        {{ hintText }}
    </div>
</div>
